var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('section', {
    staticClass: "ugc-new-top-bar row"
  }, [_c('div', {
    staticClass: "ugc-new-top-bar-logo-title-wrapper"
  }, [_c('div', {
    staticClass: "ugc-new-top-bar-logo"
  }, [_c('img', {
    attrs: {
      "src": "".concat(_vm.assetsPath, "/images/randomizer/custom_logo_red.png"),
      "alt": ""
    }
  })]), _c('div', [_c('h3', {
    staticClass: "ugc-new-top-bar-title"
  }, [_vm._v(_vm._s(_vm.translations.ugcEPTopNavTitle))])]), _c('div', {
    attrs: {
      "slot": "top-right"
    },
    slot: "top-right"
  }, [_c('button', {
    staticClass: "ugc-new-top-bar-close",
    attrs: {
      "type": "button",
      "title": "Close"
    },
    on: {
      "click": function click($event) {
        return _vm.$emit('close');
      }
    }
  }, [_c('span', {
    staticClass: "icon-close"
  })])])]), _c('div', {
    staticClass: "ugc-new-top-bar-steps-view-wrapper"
  }, [_c('ugc-new-steps-view')], 1)]);
}
var staticRenderFns = []

export { render, staticRenderFns }